import React from 'react';
import { Navbar, Container, Nav} from 'react-bootstrap';
import Logo from '../../images/logo2_blanco.png'
import './header.css'
<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');
</style>

export default function Header() {
  return <div>
        <Navbar fixed="top" collapseOnSelect expand="lg" bg="dark" variant="dark">
          <Container>
          <Navbar.Brand href="/"><img style={{height:'35px'}} src={Logo} alt=""/></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
            </Nav>
            <Nav className="fuente">
              <Nav.Link href="/">Inicio</Nav.Link>
              <Nav.Link href="/about">Sobre Nosotros</Nav.Link>
              <Nav.Link href="/refs">Referencias</Nav.Link>
              <Nav.Link href="/contact">Contacto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          </Container>
        </Navbar>
  </div>
}
